export const decamelize = (camelizedString: string): string => (
  camelizedString.replace(/-/g, " ")
);

export const capitalize = (string: string, capitalizeAll = false): string => {
  let newString = string;
  if (newString.includes('-')) {
    newString = decamelize(newString);
  }

  let newStringTail = newString.slice(1).toLowerCase();
  if (capitalizeAll) {
    newStringTail = newStringTail.replace(/(?:^|\s)\S/g, (a) => a.toUpperCase());
  }

  return `${newString.charAt(0).toUpperCase()}${newStringTail}`;
};
